export default "<st-staff-manager team=\"$ctrl.teamInfo\" user=\"$ctrl.userInfo\" roles=\"$ctrl.roleInfo\" mode=\"$ctrl.mode\"></st-staff-manager>";